<template>

<section class="pt-0" v-if="$root.instance">
  <notifications/>
  <div class="alert alert-danger" v-if="occupied.length > 0">
    <strong>Error!</strong> Selected Room Not Available.
  </div>
  <h3 class="h4">Choose accommodation:</h3>

  <!-- Show Accomodation New Design -->
  <template v-if="$root.accommodationNewDesign == 'yes'">
    <div class="row" v-for="(accommodation, index) in accommodation" :key="'accom' + index">
      <template v-if="accommodation.check_in_day == 1">
        <template v-if="accommodation.details.short_description && accommodation.details.gallery_image_link[0]['link']">
          <div class="col-md-12">
            <div class="card" style="box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-5">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="card-image-outer">
                              <template v-if="accommodation.details.gallery_image_link[0]['link']">
                                <img :src="accommodation.details.gallery_image_link[0]['link']" 
                                    class="img-fluid accommodation-image" 
                                    @click="showLightBoxImg(0, accommodation.details.gallery_image_link)"
                                    alt="" style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;">
                              </template>
                            </div>
                            <div class="thumbnails" v-if="accommodation.details.gallery_image_link[1]">
                              <template v-for="(thumnail, index) in accommodation.details.gallery_image_link">
                                <template v-if="index > 0">
                                  <img :src="thumnail.link" 
                                      :alt="`Thumbnail ${index}`" 
                                      class="thumbnail"
                                      @click="showLightBoxImg(index, accommodation.details.gallery_image_link)"
                                      :key="index">
                                </template>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-sm-12 col-md-12 col-lg-7">
                      <div class="row">
                        <div class="col-md-12 text-right">
                            <span class="star-rating">
                              <template v-for="(i, index) in 5">
                                <svg class="star star-filled" viewBox="0 0 24 24" :key="index" v-if="i <= accommodation.details.star_rating">
                                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                </svg>
                              </template>
                            </span>
                        </div>
                      </div>
                        <div class="row">
                          <div class="col-md-12">
                            <h3>{{ accommodation.details.accommodation_name }}</h3>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <p>{{ accommodation.details.short_description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="row mt-3">
                  <div class="col-md-12">
                    <h5 style="font-weight: bold;">{{ calculateAccomodationRoomCount(accommodation) }} Options Available</h5>
                  </div>
                </div>
                <div class="row accommodation-room-desktop">
                  <div class="col-md-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Occupancy</th>
                          <th>Board basis</th>
                          <th>Price per person</th>
                          <th>No. of people</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(price, index) in $root.instance.prices" >
                          <tr v-if="price.room.accommodation.id == accommodation.id && !price.room.accommodation_room.is_special" :key="'price' + index" :class="(price.room.unavailable) ? 'room-unavailable': null">
                            <td>{{ price.room.name }}</td>
                            <td>{{ price.room.occupancy }}</td>
                            <td>{{ price.room.board_basis }}</td>
                            <td v-if="price.sale_price"><del>{{price.adjusted_price | formatCurrency }}</del> {{ price.sale_price | formatCurrency }}</td>
                            <td v-else>{{price.adjusted_price | formatCurrency }}</td>
                            <!-- <td><input class="form-control" :id="'price-'+price.id" type="number" @input="selectRoom(price)" :min="price.room.occupancy" :max="price.room.occupancy"></td> -->
                            <td>
                              <template v-if="!price.room_available">
                              <span class="text-danger">SOLD OUT</span> 
                              </template>
                              <template v-else>
                                <select :id="'price-'+price.id" @change="selectRoom(price, $event.target.value)" style="width: 100px;">
                                  <option value=""></option>
                                  <option v-for="option in occupancyOptions(price.room.occupancy)" :value="option" :key="option">{{ option }}</option>
                                </select>
                              </template>
                            </td>
                            <td class="text-danger" v-if="price.room.unavailable">
                              <span >
                                Unavailable
                              </span>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="accommodation-room-mobile">
                  <div class="row" v-for="(price_mob, index_mob) in $root.instance.prices" :key="'price' + index_mob">
                    <template v-if="price_mob.room.accommodation.id == accommodation.id && !price_mob.room.accommodation_room.is_special">
                      <div class="col-md-12">
                        <div class="card">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-12">
                                <small class="accomodation-option-label">Room Type</small>
                                <h6 class="accpmmodation-option-text">{{ price_mob.room.name }}</h6>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <small class="accomodation-option-label">Board Basis</small>
                                <h6 class="accpmmodation-option-text">{{ price_mob.room.board_basis }}</h6>
                              </div>
                              <div class="col-6">
                                <small class="accomodation-option-label">Occupancy</small>
                                <h6 class="accpmmodation-option-text">{{ price_mob.room.occupancy }}</h6>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <small class="accomodation-option-label">Price per person</small>
                                <h6 class="accpmmodation-option-text">
                                  <template v-if="price_mob.sale_price"><del>{{price_mob.adjusted_price | formatCurrency }}</del> {{ price_mob.sale_price | formatCurrency }}</template>
                                  <template v-else>{{price_mob.adjusted_price | formatCurrency }}</template>
                                </h6>
                              </div>
                              <div class="col-6">
                                <small class="accomodation-option-label">No. of people</small>
                                <h6 class="accpmmodation-option-text">
                                  <template v-if="!price_mob.room_available">
                                    <span class="text-danger">SOLD OUT</span> 
                                  </template>
                                  <template v-else>
                                    <select :id="'price-'+price_mob.id" @change="selectRoom(price_mob, $event.target.value)" style="width: 100px;">
                                      <option value=""></option>
                                      <option v-for="option_mob in occupancyOptions(price_mob.room.occupancy)" :value="option_mob" :key="option_mob">{{ option_mob }}</option>
                                    </select>
                                  </template>
                                  <template v-if="price_mob.room.unavailable">
                                    <small class="text-danger">Unavailable</small>
                                  </template>
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-md-12">
            <h5>{{ accommodation.details.accommodation_name }}</h5>
            <table class="table">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Occupancy</th>
                  <th>Board basis</th>
                  <th>Price per person</th>
                  <th>No. of people</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(price, index) in $root.instance.prices" >
                  <tr v-if="price.room.accommodation.id == accommodation.id && !price.room.accommodation_room.is_special" :key="'price' + index" :class="(price.room.unavailable) ? 'room-unavailable': null">
                    <td>{{ price.room.name }}</td>
                    <td>{{ price.room.occupancy }}</td>
                    <td>{{ price.room.board_basis }}</td>
                    <td v-if="price.sale_price"><del>{{price.adjusted_price | formatCurrency }}</del> {{ price.sale_price | formatCurrency }}</td>
                    <td v-else>{{price.adjusted_price | formatCurrency }}</td>
                    <td>
                      <template v-if="!price.room_available">
                      <span class="text-danger">SOLD OUT</span> 
                      </template>
                      <template v-else>
                        <select :id="'price-'+price.id" @change="selectRoom(price, $event.target.value)">
                          <option value=""></option>
                          <option v-for="option in occupancyOptions(price.room.occupancy)" :value="option" :key="option">{{ option }}</option>
                        </select>
                      </template>
                    </td>
                    <td class="text-danger" v-if="price.room.unavailable">
                      <span >
                        Unavailable
                      </span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </template>
      </template>
    </div>
    <vue-easy-lightbox
      :visible="visible"
      :imgs="lightBox_images"
      :index="lightBoxIndex"
      @hide="handleHide"
    ></vue-easy-lightbox>
  </template>
  <!-- Show Accomodation Old Design -->
  <template v-else>
    <div class="row">
      <div class="col-md-12">
        <div v-for="(accommodation, index) in accommodation" :key="'accom' + index">
          <template v-if="accommodation.check_in_day == 1">
            <h5>{{ accommodation.details.accommodation_name }}</h5>
            <table class="table">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Occupancy</th>
                  <th>Board basis</th>
                  <th>Price per person</th>
                  <th>No. of people</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(price, index) in $root.instance.prices" >
                  <tr v-if="price.room.accommodation.id == accommodation.id && !price.room.accommodation_room.is_special" :key="'price' + index" :class="(price.room.unavailable) ? 'room-unavailable': null">
                    <td>{{ price.room.name }}</td>
                    <td>{{ price.room.occupancy }}</td>
                    <td>{{ price.room.board_basis }}</td>
                    <td v-if="price.sale_price"><del>{{price.adjusted_price | formatCurrency }}</del> {{ price.sale_price | formatCurrency }}</td>
                    <td v-else>{{price.adjusted_price | formatCurrency }}</td>
                    <td>
                      <template v-if="!price.room_available">
                       <span class="text-danger">SOLD OUT</span> 
                      </template>
                      <template v-else>
                        <select :id="'price-'+price.id" @change="selectRoom(price, $event.target.value)">
                          <option value=""></option>
                          <option v-for="option in occupancyOptions(price.room.occupancy)" :value="option" :key="option">{{ option }}</option>
                        </select>
                      </template>
                    </td>
                    <td class="text-danger" v-if="price.room.unavailable">
                      <span >
                        Unavailable
                      </span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </template>
        </div>
      </div>
    </div>
  </template>

  <br><br>

  <div class="row">
    <div class="col-md-12">
      <button class="btn btn-primary" disabled v-if="isLoading">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Loading...
      </button>
    
      <button type="submit" class="btn btn-primary" v-on:click="proceed" :disabled="!canGoNext" v-else>
        Next
      </button>
    </div>
  </div>

</section>

</template>

<script>
import axios from 'axios'
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  name: 'Accommodation',
  components: {
    VueEasyLightbox
  },
  data () {
    return {
      accommodation: [],
      occupied: [],
      isLoading:false,
      canGoNext: true,
      lightBoxIndex: 0,
      lightBox_images: [],
      visible: false,
      
    }
  },
  created () {
    this.$root.booking.tour_bookings = []
  },
  mounted () {
    // console.log(this.$root.booking.tour_bookings.length())
    // // send to beginning if arrived early at this step somehow
    // if(this.$root.booking.tour_bookings.length() < 1) {
    //   this.$router.push({ name: 'accommodation' })
    // }

    if(!this.$root.instance) {
      this.$router.push({ name: 'tour' })
    }

    // If there is accommodation assigned to the tour group use that instead of the accommodation assigned to the tour
    if(this.$root.instance.group.accommodation_count > 0) {
      this.accommodation = this.$root.instance.group.accommodation
    } else {
      this.accommodation = this.$root.instance.tour.accommodation

      // Only show the non excluded accommodation
      this.accommodation = this.accommodation.filter(accommodation => {
        return !this.$root.instance.group.excluded_accommodations.some(excluded_accommodation => {
          return (
            excluded_accommodation.accommodation_id === accommodation.accommodation_id &&
            excluded_accommodation.tour_accommodation_id === accommodation.id
          );
        });
      });
    }
  },
  methods: {
    selectRoom: function(price, selected_option) {
      
      // Get number of guests for this room
      let qty = selected_option
      console.log(selected_option);
      /**
       * Check if Selected Number of occupanyc is available for room
       */
      let roomAvailabilityObjectCheck = [{
          room_id: price.room.accommodation_room_id,
          occupancy: price.room.occupancy,
          guest: qty,
      }]
      if (qty > 0 ) {
        this.checkOccupancyAvailability(roomAvailabilityObjectCheck)
            .then(response => {
              this.isLoading = false
              let responseAvailablity = response.rooms_availability[0]
  
              let instancePrices = this.$root.instance.prices.map(price => {
                if( responseAvailablity.room_id === price.room.accommodation_room_id ) {
                  price.room.unavailable = !responseAvailablity.available;
                }
  
                return price
              });
  
              this.$root.instance.prices = instancePrices
  
              if (responseAvailablity.available) {
  
                this.canGoNext = true  
                
                // Remove existing tour_bookings from booking.tour_bookings that use this room
                this.$root.booking.tour_bookings = this.$root.booking.tour_bookings.filter(function( obj ) {
                    return obj.tour_room_id !== price.room.id;
                });
            
            
                let finalPrice = price.adjusted_price
                if(price.sale_price !== null) finalPrice = price.sale_price
            
                // Create tour_booking object
                let tour_booking = {
                  tour_id: this.$root.instance.tour.id,
                  price: finalPrice,
                  cost: price.cost,
                  tour_room_id: price.room.id,
                  guests: +qty,
                  room: price.room,
                  passengers: [],
                  instance: this.$root.instance
                }
            
                // If guests are more than zero (setting to zero removes booking) then push this tour_booking to the list
                if(tour_booking.guests > 0) this.$root.booking.tour_bookings.push(tour_booking)
            
                // Empty root passenger list
                this.$root.booking.passengers = []
            
                // For each tour_booking add the appopriate numbevr of empty passenger objects
                this.$root.booking.tour_bookings.forEach(tour_booking => {
                  tour_booking.passengers = [];
            
                  for (var i = 0; i < tour_booking.guests; i++) {
                    // Add empty passengers to main passenger list @TODO: (until we get rid of main passenger list)
                    this.$root.booking.passengers.push({
                      tour_room_id: tour_booking.tour_room_id
                    })
                    // Add empty passengers to tour booking attribute
                    tour_booking.passengers.push({})
                  }
                });
                
  
              }else{

                this.canGoNext = false
                let new_tour_boookings = this.$root.booking.tour_bookings.filter(item => item.tour_room_id != price.room.id)
                this.$root.booking.tour_bookings = new_tour_boookings
              }
            })
            .catch((error) => {
              console.log(error, 'error')
              this.$notify({
                type: 'error',
                title: error.response.data.message
              });
            })
      }else{

        let new_tour_boookings = this.$root.booking.tour_bookings.filter(item => item.tour_room_id != price.room.id)
        this.$root.booking.tour_bookings = new_tour_boookings

        let instancePrices = this.$root.instance.prices.map(element => {
          if( price.id === element.id ) {
            element.room.unavailable = false;
          }

          return element
        });

          this.$root.instance.prices = instancePrices

      }
      this.checkCanProceed()
    },
    proceed: function () {
      this.$router.push({ name: 'extras' })
      $("html, body").animate({ scrollTop: 0 }, "slow");
    },
    checkRoomAvailability() {
      this.occupied = [];
      let rooms = [];

      this.$root.booking.tour_bookings.map(booking => {
        rooms.push({ 
          room_id: booking.room.accommodation_room_id,
          occupancy: booking.room.occupancy,
          guest: booking.guests,
        });
      });

      const tour_instance_id = this.$root.instance.id;

      this.$root.loading = true;
      axios.post(this.$root.$api + 'tours/room-availability', {
        rooms,
        tour_instance_id
      })
      .then(res => res.data)
      .then(response => {
        console.log(response, 'response')
        this.$root.loading = false
        const result  = response.rooms_availability;
        this.occupied = result.filter(item => !item.available);
        $("html, body").animate({ scrollTop: 0 }, "slow");
        this.$root.instance.prices.map(price => {
          if(this.occupied.some(item => { return item.room_id === price.room.accommodation_room_id })) {
            price.room.unavailable = true;
          }else {
            price.room.unavailable = false;
          }
        });
        // On room available proceed to next step 
        if(this.occupied.length < 1) {
          this.proceed();
        };
        
      }).catch(error => {
        this.$root.loading = false
        console.log(error.response.data.message, 'error')
        this.$notify({
          type: 'error',
          title: error.response.data.message
        });
      });
    },
    occupancyOptions(occupancy) {
      const maxOccupancy = 10;
      const options = [];

      for (let i = 1; i <= maxOccupancy; i++) {
        if (occupancy === 1) {
          options.push(i);
        } else if (i % occupancy === 0) {
          options.push(i);
        }
      }

      return options;
    },
    checkOccupancyAvailability(occupancyArray) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const tour_instance_id = this.$root.instance.id;

        axios.post(this.$root.$api + 'tours/room-availability', {
          rooms:occupancyArray,
          tour_instance_id
        })
        .then(res => res.data)
        .then(response => {
          this.isLoading = false;
          resolve(response)
        }).catch(error => {
          this.isLoading = false;
          reject(error);
        });
      })
    },
    checkCanProceed() {

      let can_proceed = true;
      this.$root.instance.prices.forEach((element) => {
          if (!element.room.unavailable) {
            can_proceed = false
          }
      });

      this.canGoNext = can_proceed

    },
    calculateAccomodationRoomCount(accommodation) {
      let count = 0;
      this.$root.instance.prices.forEach((element) => {
        if (element.room.accommodation.id == accommodation.id && !element.room.accommodation_room.is_special) {
          count++
        }
      })
      return count
    },
    showLightBoxImg(index, image_array) {
      let self = this
      self.lightBox_images = []
      image_array.forEach((element) => {
        self.lightBox_images.push({
          src:element.link
        })
      })
      this.lightBoxIndex = index
      this.visible = true
    },
    handleHide() {
      this.visible = false
    }
  }
}
</script>
<style scoped>
.room-unavailable {
  background: #fbe7e9;
}
.card-image-outer{
  width: 100%;
  height: 85%;
  position: relative;
  cursor: pointer;
}
.card-image-outer img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.accommodation-room-desktop{
  display: block;
}

.accommodation-room-mobile{
  display: none;
}

.accommodation-room-mobile .accomodation-option-label {
  color:#7f7d7d
}

.thumbnails {
    display: flex;
    gap: 10px;
    margin-top: 10px;
}

.thumbnail {
    width: calc((100% - 20px) / 3);
    max-width: 100px;
    height: 60px;
    object-fit: cover;
    cursor: pointer;
}

.star-rating {
    display: inline-flex;
    align-items: center;
}
.star {
    width: 20px;
    height: 20px;
    margin-right: 2px;
}
.star-filled {
    fill: gold;
}
.star-empty {
    fill: #ccc;
}
/* Extra Small Devices (Portrait Phones) */
@media (max-width: 599px) {
  .card-image-outer{
    height: 200px;
    position: relative;
    margin-bottom: 25px;
  }

  .accommodation-room-desktop{
    display: none;
  }
  .accommodation-room-mobile{
    display: block;
  }
}

/* Small Devices (Landscape Phones) */
@media (min-width: 600px) and (max-width: 767px) {
  .card-image-outer{
    height: 200px;
    position: relative;
    margin-bottom: 25px;
  }
}

/* Medium Devices (Tablets) */
@media (min-width: 768px) and (max-width: 991px) {
  .card-image-outer{
    height: 200px;
    position: relative;
    margin-bottom: 25px;
  }
}

/* Large Devices (Desktops) */
@media (min-width: 992px) and (max-width: 1190px) {
  .card-image-outer{
    height: 200px;
    position: relative;
    margin-bottom: 25px;
  }
}

@media (min-width: 1200px) and (max-width: 1522px) {
  .card-image-outer{
    height: 75%;
  }
}

@media (min-width: 1522px){
  .card-image-outer{
    height: 85%;
  }
}



</style>